<template>
    <div>
        <base-select class="w-md-25 w-sm-100 mb-4" :loading="false" v-model="table.filters.specialtyId" :options="specialtyOptions" :label="$i18nHelpers.normalizeProp('name')" valueProp="id" :placeholder="$t('filterSpe')" @change="load()"></base-select>
        <paginated-table :fields="table.fields" :items="appointments" :empty-text="$t('appointment-history.not-found')" :stacked="stacked">
            <template v-slot:cell(preview)="data" v-if="!historyReadOnly">
                <a href="#" @click.prevent="goAppointment(data.item.id)">{{ $t('seeappointment-btn') }}</a>
                <hr v-if="stacked">
            </template>
        </paginated-table>
    </div>
</template>

<script>
import PaginatedTable from '@/components/base/PaginatedTable'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import BaseSelect from '@/components/base/forms/BaseSelect'
import BaseCard from '@/components/base/ui/BaseCard'
import filters from '@/plugins/filters'
import { uniqBy, sortBy } from 'lodash'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'

export default {
    name: 'appointment-history',
    components: {
        PaginatedTable,
        BaseSelect,
        BaseCard
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        stacked () {
            return window.innerWidth < 810
        }
    },
    mixins: [clinicHistoryMixin],
    data () {
        return {
            appointments: [],
            filters: filters,
            table: {
                fields: [
                    {
                        label: this.$t('reason-column'),
                        key: this.$i18nHelpers.normalizeProp('disease.name')
                    },
                    {
                        label: this.$t('speciality-column'),
                        key: this.$i18nHelpers.normalizeProp('speciality.name')
                    },
                    {
                        label: this.$t('type'),
                        key: this.$i18nHelpers.normalizeProp('consultationType.name')
                    },
                    {
                        label: this.$t('date'),
                        key: 'date',
                        formatter: (value, key, item) => {
                            return filters.beautifySimpleDateTime(value)
                        }
                    },
                    {
                        label: '',
                        key: 'preview'
                    }
                ],
                filters: {
                    specialtyId: null
                }
            },
            specialtyOptions: [],
            loading: false
        }
    },
    methods: {
        load () {
            this.loading = true
            ClinicHistoryRepository().getAppointments(this.table.filters.specialtyId).then((response) => {
                this.appointments = response.data.data
                this.specialtyOptions = sortBy(uniqBy(this.appointments.map((item) => item.speciality), 'id'), (item) => this.$i18nHelpers.normalize(item.name))
                this.loading = false
            })
        },
        goAppointment (id) {
            this.$store.getters['session/userIsProfessional'] ? this.$helpers.goToProfessionalWebApp(`appointments/preview/${id}`, this.$apiToken) : this.$store.getters['session/userIsCenter'] ? this.$helpers.goToCenterWebApp(`appointments/preview/${id}`, this.$apiToken) : this.$helpers.goToPatientWebApp(`appointments/preview/${id}`, this.$apiToken)
        }
    },
    created () {
        this.load()
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/shared/AppointmentHistory.vue